import { render, staticRenderFns } from "./FrictionTest.vue?vue&type=template&id=d7fa7c70&"
import script from "./FrictionTest.vue?vue&type=script&lang=js&"
export * from "./FrictionTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports